import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';
import { BaseData } from '../model/base-data.model';

@Injectable()
export class BaseDataService {

  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) { }

  getBaseData(selectedCustomerId) {
    return this.httpClient.get(`${this.rootUrl}/api/CompareBaseData/GetBaseData?cId=${selectedCustomerId}`);
  }

  getSugHafrasha() {
    return this.httpClient.get(`${this.rootUrl}/api/CompareBaseData/GetSugHafrasha`);
  }

  saveBaseData(selectedCustomerId: string, baseData: BaseData) { 
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/CompareBaseData/SaveBaseData?cId=${selectedCustomerId}`, baseData, { headers });
  }

  getBaseDataImportByFeedback(selectedCustomerId: string, month: string, isDelta: boolean) {
    return this.httpClient.get(`${this.rootUrl}/api/CompareBaseData/GetBaseDataByFeedback?cId=${selectedCustomerId}&month=${month}&isDelta=${isDelta}`);
  }

  saveBaseDataImportByFeedback(selectedCustomerId: string, baseData: BaseData, isDelta: boolean) { 
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/CompareBaseData/SaveBaseDataImportByFeedback?cId=${selectedCustomerId}&isDelta=${isDelta}`, baseData, { headers });
  }


}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/base-data.service.ts